import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';

import { SkillRoleService } from '../services/skill-role.service';

const FORBIDDEN_ROUTE = '/dashboard';

@Injectable()
export class SkillRoleGuard implements CanActivate {

  constructor(
    private skillRoleService: SkillRoleService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const requiredRoles: string[] = route.data['roles'] || [];
    if (requiredRoles.length === 0) {
      return true;
    }
    if (this.isUserAllowed(requiredRoles)) {
      return true;
    }
    this.router.navigate([FORBIDDEN_ROUTE]);
    return false;
  }

  private isUserAllowed(requiredRoles: string[]): boolean {
    if (requiredRoles.indexOf('ROLE_ADMIN') !== -1 && this.skillRoleService.isAdmin()) {
      return true;
    }
    if (requiredRoles.indexOf('ROLE_HEAD') !== -1 && this.skillRoleService.isHeadOrAdmin()) {
      return true;
    }
    if (requiredRoles.indexOf('ROLE_ADMIN_SPECIALIZATION') !== -1 && this.skillRoleService.isSpecializationAdmin()) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/guards/skill-role.guard.ts